import React from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import { Link } from "react-router";
import { autobind } from "core-decorators";
import classNames from "classnames";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import CSSModules from "react-css-modules";
import { FormattedMessage } from "react-intl";
import _get from "utils/get";
import loginUrl from "utils/url/loginUrl";
import styles from "./topBar.scss";
import MixpanelService from "../services/mixpanel";


@connect(
  state => ({
    user: state.auth.user,
    card: state.card,
    routing: state.routing
  }),
  dispatch => ({
    logout: () => dispatch(push(loginUrl()))
  })
)
@CSSModules(styles, { allowMultiple: true })
class TopBar extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    logout: PropTypes.func.isRequired,
    card: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false,
      isPrivacyPolicyMenuMenuOpen: false
    };
  }

  @autobind
  componentDidMount() {
    this.hideOnPageClick = e => {
      const elem = ReactDOM.findDOMNode(this);
      if (!this.state.isMenuOpen || elem.contains(e.target)) {
        return;
      }
      this.setState({ isMenuOpen: false });
    };

    window.addEventListener("mousedown", this.hideOnPageClick, false);
    window.addEventListener("touchend", this.hideOnPageClick, false);
  }

  @autobind
  componentWillUnmount() {
    window.removeEventListener("mousedown", this.hideOnPageClick);
    window.removeEventListener("touchend", this.hideOnPageClick);
  }

  @autobind
  toggleMenu() {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  }

  @autobind
  togglePrivacyPolicyMenu() {
    this.setState({
      isPrivacyPolicyMenuMenuOpen: !this.state.isPrivacyPolicyMenuMenuOpen
    });
  }

  @autobind
  isActiveTab(tab) {
    const pathNeam = _get(this, ["props", "routing", "locationBeforeTransitions", "pathname"], "");
    return pathNeam.indexOf(tab) >= 0;
  }

  logout() {
    MixpanelService.reset();
    this.props.logout();
  }

  render() {
    const navMenuClassName = classNames("navMenu", {
      isOpen: this.state.isMenuOpen
    });
    const userHasCard = _get(this, ["props", "card", "card", "accountId"]);
    return (
      <header styleName="topBar">
        <div styleName="startSection">
          {userHasCard && (
            <span styleName="tabs-nav">
              <Link
                data-at="tabs-nav-link-card"
                styleName={classNames("tabsNavItem", {
                  isActive: this.isActiveTab("/card")
                })}
                to={"/card/statement/last"}
              >
                <FormattedMessage id="common.tabsNav.card" />
              </Link>
              <Link
                data-at="tabs-nav-link-installments"
                styleName={classNames("tabsNavItem", {
                  isActive: this.isActiveTab("/installments")
                })}
                to={"/installments"}
              >
                <FormattedMessage id="common.tabsNav.installments" />
              </Link>
            </span>
          )}

          <a href="/" styleName="logoFull" />

          <div styleName="navMenuWrap">
            <span
              styleName="navMenuToggleButton"
              data-at="menu"
              onClick={this.toggleMenu}
            />
            <div styleName={navMenuClassName}>
              {userHasCard && (
                <div>
                  <Link
                    data-at="cardBtn"
                    styleName="menuItem"
                    to="/card/statement/last"
                  >
                    <FormattedMessage id="common.tabsNav.card" />
                  </Link>
                  <Link
                    data-at="installmentsBtn"
                    styleName="menuItem"
                    to="/installments"
                  >
                    <FormattedMessage id="common.tabsNav.installments" />
                  </Link>
                </div>
              )}
              <Link styleName="menuItem" data-at="MenuLLogout" onClick={() => this.logout()}>
                <FormattedMessage id="auth.label.signOut" />
              </Link>
            </div>
          </div>
        </div>

        <div styleName="endSection">
          <span styleName="welcome" data-at="current-user-name-text">
            Welcome {this.props.user.firstName.toLowerCase()}
          </span>
          <Link styleName="logoutLink" data-at="logoutLink" onClick={() => this.logout()}>
            Log Out
          </Link>
        </div>
      </header>
    );
  }
}

export default TopBar;



// WEBPACK FOOTER //
// ./src/root/TopBar.js